var _style, _path, _ellipse, _path2, _ellipse2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _circle, _path24;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlowerPotElla(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#388E3C;}\n\t.st1{fill:#9CCC65;}\n\t.st2{fill:#73CBBF;}\n\t.st3{fill:#282C34;}\n\t.st4{fill:#1C1A1A;}\n\t.st5{fill:#F48FB1;}\n\t.st6{fill:#F06292;}\n\t.st7{fill:#EC407A;}\n\t.st8{fill:#FFD54F;}\n\t.st9{fill:#FFCA28;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M354.8,265.2c-2.5-3.3-7.2-4-10.5-1.5L263.5,324V222c0-4.1-3.4-7.5-7.5-7.5s-7.5,3.4-7.5,7.5v101.7l-78.5-60 c-3.3-2.5-8-1.9-10.5,1.4s-1.9,8,1.4,10.5l87.6,67v8.9c0,4.1,3.4,7.5,7.5,7.5s7.5-3.4,7.5-7.5v-8.8l89.8-67 C356.6,273.2,357.3,268.5,354.8,265.2z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6108 -0.7918 0.7918 0.6108 -149.318 236.0502)",
    className: "st1",
    cx: 165.4,
    cy: 269.9,
    rx: 42.1,
    ry: 56.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M190.9,236.5c-17.7-13.6-38.8-17.6-54.5-12.1c8.1,2.3,16.1,6.4,23.6,12.1c24.7,19,33.3,49.3,19.2,67.7 c-4,5.3-9.4,9-15.7,11.2c18.5,5.4,36.8,1.7,46.6-11.2C224.2,285.8,215.6,255.5,190.9,236.5z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7918 -0.6108 0.6108 0.7918 -92.7048 268.0489)",
    className: "st1",
    cx: 346.8,
    cy: 270,
    rx: 56.4,
    ry: 42.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M391.4,235.6c-9.8-12.9-28.1-16.6-46.6-11.2c6.3,2.2,11.7,5.9,15.7,11.2c14.1,18.4,5.5,48.8-19.2,67.7 c-7.5,5.7-15.6,9.8-23.6,12.1c15.8,5.5,36.9,1.4,54.5-12.1C396.9,284.3,405.5,254,391.4,235.6L391.4,235.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M332.1,513.8H178.7c-11.5,0-20.8-12-20.8-26.8V364.4h194.9V487C352.8,501.8,343.5,513.8,332.1,513.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M316.8,364.4V487c0,14.8-12,26.8-26.8,26.8H321c14.8,0,26.8-12,26.8-26.8V364.4H316.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M368.2,386.3H139.1c-4.6,0-8.4-4.6-8.4-10.3v-26.8c0-5.7,3.7-10.3,8.4-10.3h229.1c4.6,0,8.4,4.6,8.4,10.3V376 C376.6,381.7,372.8,386.3,368.2,386.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M366.6,338.9h-30.9c5.7,0,10.3,4.6,10.3,10.3V376c0,5.7-4.6,10.3-10.3,10.3h30.9c5.7,0,10.3-4.6,10.3-10.3 v-26.8C376.9,343.5,372.3,338.9,366.6,338.9z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M334.4,83.3c-14.8,14.8-52.8,33.3-64.9,21.2s6.4-50.1,21.2-64.9s36.7-17.1,48.7-5 C351.5,46.6,349.2,68.4,334.4,83.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M339.4,34.5c-8.9-8.9-23.2-10-36-4c1.9,1.1,3.6,2.4,5.1,4c12.1,12.1,9.8,33.9-5,48.7 c-7.6,7.6-21.1,16.1-34.2,21c0.1,0.1,0.1,0.2,0.2,0.2c12.1,12.1,50.1-6.4,64.9-21.2C349.2,68.4,351.5,46.6,339.4,34.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M177.6,152.6c14.8-14.8,52.8-33.3,64.9-21.2s-6.4,50.1-21.2,64.9s-36.7,17.1-48.7,5S162.8,167.5,177.6,152.6z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M242.5,131.4c-5.9-5.9-18.1-4.5-30.7,0.2c11.6,12.3-6.7,49.9-21.4,64.7c-3.9,3.9-8.2,6.9-12.7,9 c12.5,7.3,30.7,3.9,43.6-9C236.2,181.5,254.6,143.5,242.5,131.4L242.5,131.4z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M290.7,196.3c-14.8-14.8-33.3-52.8-21.2-64.9s50.1,6.4,64.9,21.2s17.1,36.7,5,48.7S305.5,211.2,290.7,196.3z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M334.4,152.6c-14.8-14.8-52.8-33.3-64.9-21.2c-0.1,0.1-0.2,0.2-0.2,0.2c13.1,4.9,26.7,13.4,34.2,21 c14.8,14.8,17.1,36.7,5,48.7c-1.6,1.6-3.3,2.9-5.1,4c12.8,6.1,27.1,5,36-4C351.5,189.3,349.2,167.5,334.4,152.6L334.4,152.6z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M221.3,39.6c14.8,14.8,33.3,52.8,21.2,64.9s-50.1-6.4-64.9-21.2s-17.1-36.7-5-48.7S206.5,24.7,221.3,39.6z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M221.3,39.6c-12.9-12.9-31.1-16.3-43.6-9c4.5,2.1,8.8,5.1,12.7,9c14.7,14.7,33,52.4,21.4,64.7 c12.6,4.7,24.8,6.2,30.7,0.2C254.6,92.4,236.2,54.4,221.3,39.6z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M286.9,38c0,21-13.8,60.9-30.9,60.9S225.1,59,225.1,38S238.9,0,256,0S286.9,17,286.9,38z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M256,0c-5.6,0-10.9,1.9-15.5,5.1C249.8,11.7,256,23.9,256,38s-6.2,36.6-15.5,50c4.5,6.6,9.8,10.9,15.5,10.9 c17.1,0,30.9-39.9,30.9-60.9S273.1,0,256,0z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M225.1,197.9c0-21,13.8-60.9,30.9-60.9s30.9,39.9,30.9,60.9s-13.8,38-30.9,38S225.1,218.9,225.1,197.9 L225.1,197.9z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M256,137c-5.6,0-10.9,4.3-15.5,10.9c9.2,13.4,15.5,35.9,15.5,50s-6.2,26.3-15.5,32.9c4.5,3.2,9.8,5.1,15.5,5.1 c17.1,0,30.9-17,30.9-38S273.1,137,256,137z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M336,148.9c-21,0-60.9-13.8-60.9-30.9S315,87.1,336,87.1s38,13.8,38,30.9S356.9,148.9,336,148.9z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M336,87.1c-4.9,0-10.8,0.8-17,2.1c14,4.5,24,15.7,24,28.8s-10,24.3-24.1,28.8c6.2,1.4,12.1,2.1,17,2.1 c21,0,38-13.8,38-30.9S356.9,87.1,336,87.1z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M176,87.1c21,0,60.9,13.8,60.9,30.9S197,148.9,176,148.9S138,135,138,118S155.1,87.1,176,87.1z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M176,87.1c-4.9,0-9.6,0.8-13.9,2.1c20.4,4.5,43.9,15.7,43.9,28.8s-23.5,24.3-43.9,28.8c4.3,1.4,9,2.1,13.9,2.1 c21,0,60.9-13.8,60.9-30.9S197,87.1,176,87.1z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 256,
    cy: 118,
    r: 39.1
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M256,78.8c-5.5,0-10.7,1.1-15.5,3.2c13.9,6,23.7,19.8,23.7,36s-9.8,30-23.7,36c4.7,2,10,3.2,15.5,3.2 c21.6,0,39.1-17.5,39.1-39.1S277.6,78.8,256,78.8z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowerPotElla);
export default __webpack_public_path__ + "static/media/flower-pot-ella.6a6f936fca5de88cd4b85c4dd3e3cb07.svg";
export { ForwardRef as ReactComponent };